import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalFooter,
    ModalCloseButton,
    Button,
    VStack,
    Text,
    Image, Flex,
} from "@chakra-ui/react";
import info from "../../assets/images/info.svg";

const SuccessModal = ({ isOpen, onClose, eventTitle }) => {
    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="2xl">
            <ModalOverlay />
            <ModalContent p={{base: '16px', md: '48px'}} gap={'48px'}>
                <ModalHeader>
                    <Flex flexDirection={"column"} gap={'16px'}>
                        <Text fontFamily={'Poppins'} fontWeight={'700'} fontSize={'24px'} lineHeight={'100%'} color={'#363636'}>
                            Zapisz się na wydarzenie
                        </Text>
                        <Text fontFamily={'Poppins'} fontWeight={'400'} fontSize={'16px'} lineHeight={'100%'} color={'#363636'}>
                            {eventTitle}
                        </Text>
                    </Flex>
                </ModalHeader>
                <ModalCloseButton mt={'45px'} mr={'45px'} size={"lg"}/>
                <ModalBody>
                    <Flex flexDirection={"column"} gap={'32px'} textAlign="center" alignItems={"center"}>
                        <Image src={info} w={'96px'} h={'96px'} />
                        <Text fontFamily={'Poppins'} fontWeight={'700'} fontSize={'24px'} lineHeight={'100%'}>
                            Twoja rejestracja na wydarzenie przebiegła pomyślnie!
                        </Text>
                        <Text fontFamily={'Poppins'} fontWeight={'400'} fontSize={'16px'} lineHeight={'100%'}>
                            Na adres e-mail podany w formularzu wysłaliśmy potwierdzenie Twojego zapisu na wydarzenie.
                        </Text>
                    </Flex>
                </ModalBody>

                <ModalFooter justifyContent="center">
                    <Button variant="outline" colorScheme="green" onClick={onClose} gap={'10px'} w={'215px'} h={'50px'}
                            border={'2px'} borderColor={'#0A4725'} borderRadius={0}>
                        Zamknij
                        <svg width="9" height="10" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M0.5 0H4.08481L8.5 5L4.08481 10H0.5L4.93544 5L0.5 0Z" fill="#0A4725"/>
                        </svg>
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};

export default SuccessModal;
